import { toast } from "react-toastify";
import { normalizePhoneNumber } from "./contactNormalizer";
import { buildWhatsAppMessage } from "./messageBuilder";

export const handleWhatsAppNotify = (row) => {
  const phone = normalizePhoneNumber(row.phoneNo);

  if (!phone) {
    toast.error("Phone number not available");
    return;
  }

  const message = buildWhatsAppMessage(row);
  const encodedMessage = encodeURIComponent(message);

  const url = `https://wa.me/${phone}?text=${encodedMessage}`;

  window.open(url, "_blank");
};